import * as _ from 'lodash';

export function getTicketsFromExectutionToLoad(ticketSets) {
    const ticketsList = _.map(ticketSets, (ticketSet) => ticketSet.tickets);
    return _.flatten(ticketsList);
}

export default getTicketsFromExectutionToLoad;
